/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ObtenerDatosDepositoME } from '../model/obtenerDatosDepositoME';
import { ObtenerDatosDepositoMS } from '../model/obtenerDatosDepositoMS';
import { ObtenerDepositoDetalleMovimientosME } from '../model/obtenerDepositoDetalleMovimientosME';
import { ObtenerDepositoDetalleMovimientosMS } from '../model/obtenerDepositoDetalleMovimientosMS';
import { ObtenerInformacionAdicionalDepositoME } from '../model/obtenerInformacionAdicionalDepositoME';
import { ObtenerInformacionAdicionalDepositoMS } from '../model/obtenerInformacionAdicionalDepositoMS';
import { ObtenerMovimientosDepositoChequeME } from '../model/obtenerMovimientosDepositoChequeME';
import { ObtenerMovimientosDepositoChequeMS } from '../model/obtenerMovimientosDepositoChequeMS';
import { ObtenerMovimientosDepositoME } from '../model/obtenerMovimientosDepositoME';
import { ObtenerMovimientosDepositoMS } from '../model/obtenerMovimientosDepositoMS';
import { ObtenerRequisitosTablaPresuntivaTipoDepositoME } from '../model/obtenerRequisitosTablaPresuntivaTipoDepositoME';
import { ObtenerRequisitosTablaPresuntivaTipoDepositoMS } from '../model/obtenerRequisitosTablaPresuntivaTipoDepositoMS';
import { ObtenerTablaPresuntivaDepositoImpresionME } from '../model/obtenerTablaPresuntivaDepositoImpresionME';
import { ObtenerTablaPresuntivaDepositoImpresionMS } from '../model/obtenerTablaPresuntivaDepositoImpresionMS';
import { ObtenerTasaComponenteDepositoME } from '../model/obtenerTasaComponenteDepositoME';
import { ObtenerTasaComponenteDepositoMS } from '../model/obtenerTasaComponenteDepositoMS';
import { ObtenerTiposDepositoME } from '../model/obtenerTiposDepositoME';
import { ObtenerTiposDepositoMS } from '../model/obtenerTiposDepositoMS';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DepositoService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10DepositoObtenerDatosDepositoPost(body?: ObtenerDatosDepositoME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerDatosDepositoMS>;
    public apiV10DepositoObtenerDatosDepositoPost(body?: ObtenerDatosDepositoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerDatosDepositoMS>>;
    public apiV10DepositoObtenerDatosDepositoPost(body?: ObtenerDatosDepositoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerDatosDepositoMS>>;
    public apiV10DepositoObtenerDatosDepositoPost(body?: ObtenerDatosDepositoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerDatosDepositoMS>('post',`${this.basePath}/api/v1.0/Deposito/ObtenerDatosDeposito`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10DepositoObtenerDepositoDetalleMovimientosPost(body?: ObtenerDepositoDetalleMovimientosME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerDepositoDetalleMovimientosMS>;
    public apiV10DepositoObtenerDepositoDetalleMovimientosPost(body?: ObtenerDepositoDetalleMovimientosME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerDepositoDetalleMovimientosMS>>;
    public apiV10DepositoObtenerDepositoDetalleMovimientosPost(body?: ObtenerDepositoDetalleMovimientosME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerDepositoDetalleMovimientosMS>>;
    public apiV10DepositoObtenerDepositoDetalleMovimientosPost(body?: ObtenerDepositoDetalleMovimientosME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerDepositoDetalleMovimientosMS>('post',`${this.basePath}/api/v1.0/Deposito/ObtenerDepositoDetalleMovimientos`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10DepositoObtenerInformacionAdicionalDepositoPost(body?: ObtenerInformacionAdicionalDepositoME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerInformacionAdicionalDepositoMS>;
    public apiV10DepositoObtenerInformacionAdicionalDepositoPost(body?: ObtenerInformacionAdicionalDepositoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerInformacionAdicionalDepositoMS>>;
    public apiV10DepositoObtenerInformacionAdicionalDepositoPost(body?: ObtenerInformacionAdicionalDepositoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerInformacionAdicionalDepositoMS>>;
    public apiV10DepositoObtenerInformacionAdicionalDepositoPost(body?: ObtenerInformacionAdicionalDepositoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerInformacionAdicionalDepositoMS>('post',`${this.basePath}/api/v1.0/Deposito/ObtenerInformacionAdicionalDeposito`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10DepositoObtenerMovimientosDepositoChequePost(body?: ObtenerMovimientosDepositoChequeME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerMovimientosDepositoChequeMS>;
    public apiV10DepositoObtenerMovimientosDepositoChequePost(body?: ObtenerMovimientosDepositoChequeME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerMovimientosDepositoChequeMS>>;
    public apiV10DepositoObtenerMovimientosDepositoChequePost(body?: ObtenerMovimientosDepositoChequeME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerMovimientosDepositoChequeMS>>;
    public apiV10DepositoObtenerMovimientosDepositoChequePost(body?: ObtenerMovimientosDepositoChequeME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerMovimientosDepositoChequeMS>('post',`${this.basePath}/api/v1.0/Deposito/ObtenerMovimientosDepositoCheque`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10DepositoObtenerMovimientosDepositoPost(body?: ObtenerMovimientosDepositoME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerMovimientosDepositoMS>;
    public apiV10DepositoObtenerMovimientosDepositoPost(body?: ObtenerMovimientosDepositoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerMovimientosDepositoMS>>;
    public apiV10DepositoObtenerMovimientosDepositoPost(body?: ObtenerMovimientosDepositoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerMovimientosDepositoMS>>;
    public apiV10DepositoObtenerMovimientosDepositoPost(body?: ObtenerMovimientosDepositoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerMovimientosDepositoMS>('post',`${this.basePath}/api/v1.0/Deposito/ObtenerMovimientosDeposito`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10DepositoObtenerRequisitosTablaPresuntivaTipoDepositoPost(body?: ObtenerRequisitosTablaPresuntivaTipoDepositoME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerRequisitosTablaPresuntivaTipoDepositoMS>;
    public apiV10DepositoObtenerRequisitosTablaPresuntivaTipoDepositoPost(body?: ObtenerRequisitosTablaPresuntivaTipoDepositoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerRequisitosTablaPresuntivaTipoDepositoMS>>;
    public apiV10DepositoObtenerRequisitosTablaPresuntivaTipoDepositoPost(body?: ObtenerRequisitosTablaPresuntivaTipoDepositoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerRequisitosTablaPresuntivaTipoDepositoMS>>;
    public apiV10DepositoObtenerRequisitosTablaPresuntivaTipoDepositoPost(body?: ObtenerRequisitosTablaPresuntivaTipoDepositoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerRequisitosTablaPresuntivaTipoDepositoMS>('post',`${this.basePath}/api/v1.0/Deposito/ObtenerRequisitosTablaPresuntivaTipoDeposito`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10DepositoObtenerTablaPresuntivaDepositoImpresionPost(body?: ObtenerTablaPresuntivaDepositoImpresionME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerTablaPresuntivaDepositoImpresionMS>;
    public apiV10DepositoObtenerTablaPresuntivaDepositoImpresionPost(body?: ObtenerTablaPresuntivaDepositoImpresionME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerTablaPresuntivaDepositoImpresionMS>>;
    public apiV10DepositoObtenerTablaPresuntivaDepositoImpresionPost(body?: ObtenerTablaPresuntivaDepositoImpresionME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerTablaPresuntivaDepositoImpresionMS>>;
    public apiV10DepositoObtenerTablaPresuntivaDepositoImpresionPost(body?: ObtenerTablaPresuntivaDepositoImpresionME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerTablaPresuntivaDepositoImpresionMS>('post',`${this.basePath}/api/v1.0/Deposito/ObtenerTablaPresuntivaDepositoImpresion`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10DepositoObtenerTasaComponenteDepositoPost(body?: ObtenerTasaComponenteDepositoME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerTasaComponenteDepositoMS>;
    public apiV10DepositoObtenerTasaComponenteDepositoPost(body?: ObtenerTasaComponenteDepositoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerTasaComponenteDepositoMS>>;
    public apiV10DepositoObtenerTasaComponenteDepositoPost(body?: ObtenerTasaComponenteDepositoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerTasaComponenteDepositoMS>>;
    public apiV10DepositoObtenerTasaComponenteDepositoPost(body?: ObtenerTasaComponenteDepositoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerTasaComponenteDepositoMS>('post',`${this.basePath}/api/v1.0/Deposito/ObtenerTasaComponenteDeposito`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10DepositoObtenerTiposDepositoPost(body?: ObtenerTiposDepositoME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerTiposDepositoMS>;
    public apiV10DepositoObtenerTiposDepositoPost(body?: ObtenerTiposDepositoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerTiposDepositoMS>>;
    public apiV10DepositoObtenerTiposDepositoPost(body?: ObtenerTiposDepositoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerTiposDepositoMS>>;
    public apiV10DepositoObtenerTiposDepositoPost(body?: ObtenerTiposDepositoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerTiposDepositoMS>('post',`${this.basePath}/api/v1.0/Deposito/ObtenerTiposDeposito`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
